import React from 'react';
import cx from 'classnames';
import { useIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';

import Logo from '../../Logo/Logo';
import { SideMenuSection } from './SideMenuSection';

import {
	getDashboardSideMenu, getUsersSideMenu, getConfigurationSideMenu,
	getAdminConfigSideMenu, getListSettingsMenu, getListingMenu, getReservationMenu,
	getContentPageMenu
} from '../../../helpers/getSideMenuData';
import messages from '../../../locale/messages';

import { UnderLineSvgIcon } from '../../Common/Assets/SvgComponent/SiteAdminSvgIcon';
import s from './SideBar.css';

function SideBar(props) {
	const { handleMobileMenu, location, isSuperAdmin, privileges, logoImage,listingApproval } = props;
	const intl = useIntl();

	const sideMenu = [
		{ menuData: getDashboardSideMenu, label: null },
		{ menuData: getConfigurationSideMenu, label: intl.formatMessage(messages.configurations) },
		{ menuData: getAdminConfigSideMenu, label: intl.formatMessage(messages.adminConfigurations) },
		{ menuData: getUsersSideMenu, label: intl.formatMessage(messages.usersLabel) },
		{ menuData: getListSettingsMenu, label: intl.formatMessage(messages.listingSettings) },
		{ menuData: getListingMenu, label: intl.formatMessage(messages.singularListingLabel) },
		{ menuData: getReservationMenu, label: intl.formatMessage(messages.reservationMenu) },
		{ menuData: getContentPageMenu, label: intl.formatMessage(messages.contentPages) }
	];

	return (
		<div className={s.sideMenuContent}>
			<div className={s.siteAdminHeader}>
				<div className={cx(logoImage && s.sideMenuHeaderLogoContainer)}>
					<Logo link={"/siteadmin"} className={cx(logoImage ? s.sideMenuHeaderLogo : s.sideMenuHeaderLogoText)} />
				</div>
				<FormattedMessage {...messages.welcomeAdmin} />
				<UnderLineSvgIcon className={s.siteAdminHeaderUnderLine} />
			</div>
			<div className={s.sideMenuBody}>
				{sideMenu?.map((item, key) => {
					return (
						<SideMenuSection
							key={key}
							handleMobileMenu={handleMobileMenu}
							menuData={item?.menuData}
							label={item?.label}
							location={location}
							isSuperAdmin={isSuperAdmin}
							privileges={privileges}
							listingApproval={listingApproval}
						/>
					)
				})}
			</div>
		</div>
	)
}

const mapState = (state) => ({
	isSuperAdmin: state.runtime.isSuperAdmin,
	privileges: state.adminPrevileges.privileges && state.adminPrevileges.privileges.privileges,
	logoImage: state.siteSettings.data.Logo,
	listingApproval: state.siteSettings.data.listingApproval
});

const mapDispatch = {
};

export default withStyles(s)(connect(mapState, mapDispatch)(SideBar));